import { createAuth0 } from '@auth0/auth0-vue';
import { appRootUrl } from './appRootUrl';

/**
 * The audience every DaaS service in this shell is registered against.
 *
 * One access token is accepted by the query service, the intake service and the
 * rules API, which is why a single Auth0 application serves all of them.
 */
export const AUDIENCE = 'https://daas.performx.dev';

export const auth0 = createAuth0(
    {
        domain: 'one10-nonprod.us.auth0.com',
        clientId: 'rFET2diLIgm36Bst334iYFLfAx8VvQxA',
        authorizationParams: {
            redirect_uri: appRootUrl(),
            audience: AUDIENCE,
            scope: 'openid profile email offline_access',
        },
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
    },
    {
        // A failed callback lands on the tenant picker, which already renders
        // `useAuth0().error`. The default ('/') would show the app index with no
        // explanation of why sign-in did not take.
        errorPath: '/login',
    },
);
